let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lWi9V")).then(() => parcelRequire('7VoZf'));